var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showingFolders)?_c('FolderSelector',{attrs:{"type":_vm.type}}):_c('ImageSelector')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }